import { Observable } from 'rxjs';
import { CreateQuoteRequest, CreateQuoteResponse } from '../../interfaces/quote/quote.interface';

export abstract class QuoteRepository {
  abstract createQuote(request: CreateQuoteRequest): Observable<CreateQuoteResponse>;
}
